import React, { useState, useEffect } from 'react';
import { X, EyeOff } from 'lucide-react';
import TipForm from './TipForm';

/**
 * Floating "Got a Tip?" FAB + modal wrapper. Form lives in TipForm.jsx so
 * the same code powers the standalone /tip share page.
 */
const SubmitTipButton = () => {
  const [open, setOpen] = useState(false);

  // Lock body scroll while modal open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [open]);

  return (
    <>
      {/* Floating Action Button - muted, no pulse/halo/gradient */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="submit-tip-button"
        aria-label="Submit a tip"
        className="group fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-red-600 hover:bg-red-500 text-white font-bold text-[13px] uppercase tracking-wider border border-red-400/30 transition-colors duration-150"
      >
        <EyeOff className="h-4 w-4" />
        <span>Got a Tip?</span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/85 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4 overflow-y-auto"
          onClick={() => setOpen(false)}
          data-testid="submit-tip-modal-backdrop"
        >
          <div
            className="bg-zinc-950 border border-red-900/50 w-full max-w-lg rounded-t-2xl sm:rounded-2xl shadow-2xl relative animate-slide-up"
            onClick={(e) => e.stopPropagation()}
            data-testid="submit-tip-modal"
          >
            <button
              type="button"
              onClick={() => setOpen(false)}
              data-testid="submit-tip-close-btn"
              aria-label="Close"
              className="absolute top-3 right-3 text-gray-400 hover:text-white z-10"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="p-5 sm:p-6">
              <TipForm compact onDone={() => setOpen(false)} />
            </div>
          </div>
          <style>{`
            @keyframes slide-up { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            .animate-slide-up { animation: slide-up 0.2s ease-out; }
          `}</style>
        </div>
      )}
    </>
  );
};

export default SubmitTipButton;
